import { useAppDispatch, useAppSelector } from "@builder/store/store";
import "./style.scss";
import Snackbar from "@mui/material/Snackbar";
import OliverText from "@builder/components/general/OliverText";
import { setSnackbar } from "@builder/store/slices/BuilderSlice/builderSlice";

const SnackbarNotification = () => {
    const dispatch = useAppDispatch();
    const snackbarOptions = useAppSelector(state => state.builder.snackbar);

    const onClose = () => {
        dispatch(setSnackbar(null));
    };

    const message = (
        <div className="snackbar-message">
            <img src="./final-logo.svg" alt="" />
            <OliverText text={snackbarOptions?.message || ""} size="m" weight="medium-heavy" />
        </div>
    );

    return (
        <Snackbar
            open={!!snackbarOptions}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            autoHideDuration={snackbarOptions?.duration || 3000}
            onClose={onClose}
            message={message}
            className="snackbar-notification"
        />
    );
};

export default SnackbarNotification;
